export default "__VITE_ASSET__1zc4WULU__"